import dayjs from 'dayjs';
import { userFields } from './UserSchema';

export const transformUserToForm = (user) => {
  const data = userFields.reduce((obj, key) => {
    if (key === 'start_date' || key === 'dob') {
      obj[key] = dayjs(user[key]).format('YYYY-MM-DD');
    } else {
      obj[key] = user[key] || '';
    }

    return obj;
  }, {});
  return data;
};

export const handleFullName = (payload) => {
  const { first_name, last_name } = payload;
  return [first_name.trim(), last_name.trim()].join(' ');
};
